<template>
    <div class="user-company-create">
        <data-form title="Associate User with Company"
                   tag="user-company-create"
                   save-button-label="Create Association"
                   :field-model="companyUser"
                   :field-groups="fieldGroups"
                   :disabledFields="disabledFields"
                   :on-submit-handler="onSubmit"
                   :cancelRoute="`/user/view/${userId}`"
                   :load-model-instance="loadModelInstance"
                   submit-success-message="User company info created"
                   submit-error-message="Error creating association">
        </data-form>
    </div>
</template>

<script>

import Vue from 'vue'
import CompanyUser from '@/models/CompanyUser'

export default Vue.extend({
    name: 'CompanyUserCreate',
    props: {
        userId: Number,
        companyId: Number,
    },
    data () {
        return {
            companyUser: CompanyUser,
            disabledFields: ['user_full_name'],
            userInfo: {},
        }
    },
    computed: {
        fieldGroups () {
            let fieldGroupLeft = ['user_full_name', 'company_id']
            let fieldGroupRight = [
                'is_company_admin',
            ]
            return [fieldGroupLeft, fieldGroupRight]
        },
    },
    methods: {
        loadModelInstance () {
            return this.$api.getItem(this, 'user', this.userId)
                .then((user) => {
                    return {
                        user_id: this.userId,
                        user_full_name: user.full_name
                    }
                })
        },
        onSubmit (modelInstance) {
            return this.$api.createItem(this, 'company-user', modelInstance)
                .then(async (response) => {
                    this.$router.push(`/user/view/${this.userId}`)
                })
        }
    },
})

</script>
